module.exports = __webpack_public_path__ + "static/mr-concert-performance-03-2202dd659fa6b184688831b5fc55d689.jpg";